<template>
  <card>
    <product-rule-form @submit="onSubmit"></product-rule-form>
  </card>
</template>
<script>
  import ProductRuleForm from './ProductRuleForm'
  import ProductService from 'src/services/ProductService'
  export default {
    name: 'product-rule-create',
    components: {
      ProductRuleForm
    },
    methods: {
      async onSubmit (data) {
        let productId = this.$route.params.id;
        await ProductService.createProductRule(productId, data);
        this.$router.push(`/settings/products/${productId}`);
      }
    }
  }
</script>
